
(() => {
    function moneyFormatFromTheme(cents) {
        // Symmetry зазвичай має theme.money / theme.formatMoney.
        // Якщо є - використовуємо. Якщо ні - простий fallback.
        try {
            if (window.theme && typeof window.theme.formatMoney === "function") {
                return window.theme.formatMoney(cents);
            }
        } catch (e) {}
        return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
    }

    function normalize(str) {
        return String(str || "").trim();
    }

    function firstWord(str) {
        const s = normalize(str);
        if (!s) return "";
        return s.split(/\s+/)[0];
    }

    class ConfiguratorModal {
        constructor(modalEl) {
            this.modal = modalEl;
            this.panel = modalEl.querySelector(".cfg-modal__panel");
            this.closeEls = modalEl.querySelectorAll("[data-cfg-close]");
            this.overlay = modalEl.querySelector(".cfg-modal__overlay");
            this.tabs = modalEl.querySelectorAll("[data-cfg-tab]");
            this.panes = modalEl.querySelectorAll("[data-cfg-pane]");
            this.priceEl = modalEl.querySelector("[data-cfg-price]");
            this.selectBtn = modalEl.querySelector("[data-cfg-select]");
            this.jsonEl = modalEl.querySelector("[data-cfg-product-json]");

            this.baseWrap = modalEl.querySelector('[data-cfg-options="base"]');
            this.configWrap = modalEl.querySelector('[data-cfg-options="configuration"]');
            this.fabricGroupsWrap = modalEl.querySelector("[data-cfg-fabric-groups]");
            this.relatedWrap = modalEl.querySelector("[data-cfg-related]");

            this.state = {
                activeTab: "colour",
                selected: {}, // key: optionName => value
                currentVariant: null,
                product: null
            };
        }

        init() {
            this.closeEls.forEach((btn) => btn.addEventListener("click", () => this.close()));
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && this.isOpen()) this.close();
            });

            this.tabs.forEach((t) =>
                t.addEventListener("click", () => this.setTab(t.getAttribute("data-cfg-tab")))
            );

            this.selectBtn.addEventListener("click", () => this.addToCart());


            this.loadFromEmbeddedJSON();
            this.renderAll();
            this.syncVariant();
        }

        loadFromEmbeddedJSON() {
            const data = JSON.parse(this.jsonEl.textContent);
            this.state.product = data;

            // Автовибір перших значень (щоб Select/price одразу з’явились)
            // Беремо перший available variant
            const firstAvailable = data.variants.find(v => v.available) || data.variants[0];
            if (firstAvailable) {
                data.options.forEach((optName, idx) => {
                    this.state.selected[optName] = firstAvailable.options[idx];
                });
            }
        }


        isOpen() {
            return this.modal.classList.contains("is-open");
        }

        open() {
            this.modal.classList.add("is-open");
            this.modal.setAttribute("aria-hidden", "false");
            document.documentElement.classList.add("cfg-modal-open");
        }

        close() {
            this.modal.classList.remove("is-open");
            this.modal.setAttribute("aria-hidden", "true");
            document.documentElement.classList.remove("cfg-modal-open");
        }

        setTab(tabName) {
            this.state.activeTab = tabName;

            this.tabs.forEach((t) => t.classList.toggle("is-active", t.getAttribute("data-cfg-tab") === tabName));
            this.panes.forEach((p) => p.classList.toggle("is-active", p.getAttribute("data-cfg-pane") === tabName));
        }

        renderAll() {
            this.renderBaseColour();
            this.renderFabricColour();
            this.renderConfigurations();
        }

        // ВАЖЛИВО: тут треба точні назви option’ів.
        // Я роблю підхід “знайти по назві”
        findOptionIndex(optionName) {
            const opts = this.state.product?.options || [];
            return opts.findIndex(o => normalize(o).toLowerCase() === normalize(optionName).toLowerCase());
        }

        renderBaseColour() {
            const idx = this.findOptionIndex("Base Colour");
            if (idx === -1) {
                this.baseWrap.innerHTML = "<div class='cfg-empty'>No Base Colour option</div>";
                return;
            }

            const values = new Set();
            this.state.product.variants.forEach(v => values.add(v.options[idx]));
            const arr = Array.from(values);

            this.baseWrap.innerHTML = arr.map((val) => {
                const active = this.state.selected["Base Colour"] === val;
                return `<button type="button" class="cfg-pill${active ? " is-active" : ""}" data-cfg-pick="Base Colour" data-cfg-value="${this.escape(val)}">${this.escape(val)}</button>`;
            }).join("");

            this.baseWrap.onclick = (e) => {
                const btn = e.target.closest("[data-cfg-pick='Base Colour']");
                if (!btn) return;
                this.state.selected["Base Colour"] = btn.getAttribute("data-cfg-value");
                this.renderAll();
                this.syncVariant();
            };
        }

        renderFabricColour() {
            const idx = this.findOptionIndex("Fabric Type");
            if (idx === -1) {
                this.fabricGroupsWrap.innerHTML = "<div class='cfg-empty'>No Fabric Colour option</div>";
                return;
            }

            // групування: metafield fabric_group (краще) або перше слово з назви
            const groups = new Map(); // groupName -> values[]
            this.state.product.variants.forEach(v => {
                const val = v.options[idx];
                const g = normalize(v.fabric_group) || firstWord(val) || "Other";
                if (!groups.has(g)) groups.set(g, new Set());
                groups.get(g).add(val);
            });

            const html = Array.from(groups.entries()).map(([groupName, set]) => {
                const values = Array.from(set);

                const items = values.map((val) => {
                    const active = this.state.selected["Fabric Type"] === val;
                    return `<button type="button" class="cfg-swatch${active ? " is-active" : ""}" data-cfg-pick="Fabric Type" data-cfg-value="${this.escape(val)}">
            <span class="cfg-swatch__label">${this.escape(val)}</span>
          </button>`;
                }).join("");

                return `<div class="cfg-group">
          <div class="cfg-group__title">${this.escape(groupName)}</div>
          <div class="cfg-group__grid">${items}</div>
        </div>`;
            }).join("");

            this.fabricGroupsWrap.innerHTML = html;

            this.fabricGroupsWrap.onclick = (e) => {
                const btn = e.target.closest("[data-cfg-pick='Fabric Type']");
                if (!btn) return;
                this.state.selected["Fabric Type"] = btn.getAttribute("data-cfg-value");
                this.renderAll();
                this.syncVariant();
            };
        }

        renderConfigurations() {
            const idx = this.findOptionIndex("Configuration");
            if (idx === -1) {
                this.configWrap.innerHTML = "<div class='cfg-empty'>No Configuration option</div>";
                return;
            }

            const items = [];
            const used = new Set();

            this.state.product.variants.forEach(v => {
                const val = v.options[idx];
                if (used.has(val)) return;
                used.add(val);

                const active = this.state.selected["Configuration"] === val;

                // якщо є картинка з metafield (з embedded JSON) — показуємо
                const img = v.configuration_image ? `<img class="cfg-card__img" src="${this.escape(v.configuration_image)}" alt="">` : "";
                items.push(`<button type="button" class="cfg-card${active ? " is-active" : ""}" data-cfg-pick="Configuration" data-cfg-value="${this.escape(val)}">
          ${img}
          <span class="cfg-card__title">${this.escape(val)}</span>
        </button>`);
            });

            this.configWrap.innerHTML = items.join("");

            this.configWrap.onclick = (e) => {
                const btn = e.target.closest("[data-cfg-pick='Configuration']");
                if (!btn) return;
                this.state.selected["Configuration"] = btn.getAttribute("data-cfg-value");
                this.renderAll();
                this.syncVariant();
            };
        }

        syncVariant() {
            const p = this.state.product;
            if (!p) return;

            // match variant по повному набору options
            const wanted = p.options.map((optName) => this.state.selected[optName]);
            const match = p.variants.find(v => v.options.every((val, idx) => val === wanted[idx]));

            this.state.currentVariant = match || null;

            if (match) {
                this.priceEl.textContent = moneyFormatFromTheme(match.price);
                this.selectBtn.disabled = !match.available;
            } else {
                this.priceEl.textContent = "";
                this.selectBtn.disabled = true;
            }
        }

        async addToCart() {
            const v = this.state.currentVariant;
            if (!v || !v.id) return;

            this.selectBtn.disabled = true;

            try {
                const formData = new FormData();
                formData.append("id", String(v.id));
                formData.append("quantity", "1");

                const res = await fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                    headers: { Accept: "application/json" }
                });

                if (!res.ok) throw new Error("Add to cart failed");

                if (window.theme?.settings?.after_add_to_cart === "page") {
                    window.location = window.theme.routes.cart_url;
                    return;
                }

                if (window.theme?.settings?.after_add_to_cart === "drawer") {
                    document.documentElement.dispatchEvent(
                        new CustomEvent("theme:cartchanged", { bubbles: true, detail: { openDrawer: true } })
                    );
                } else {
                    document.documentElement.dispatchEvent(
                        new CustomEvent("theme:cartchanged", { bubbles: true })
                    );
                }

                this.close();
            } catch (e) {
                console.error(e);
                this.selectBtn.disabled = false;
            }
        }

        escape(s) {
            return String(s ?? "").replace(/[&<>"']/g, (m) => ({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#039;"
            }[m]));
        }
    }

    function notifyCartChanged(openDrawer) {
        const detail = openDrawer ? { openDrawer: true } : {};
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:cartchanged", {
                bubbles: true,
                cancelable: false,
                detail
            })
        );
    }

    async function addVariantToCart(variantId, qty = 1) {
        const formData = new FormData();
        formData.append("id", String(variantId));
        formData.append("quantity", String(qty));

        const res = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: { Accept: "application/json" }
        });

        // Shopify часто повертає 422 з JSON error
        const data = await res.json().catch(() => null);

        if (!res.ok) {
            const msg =
                (data && (data.description || data.message)) ||
                "Add to cart failed";
            throw new Error(msg);
        }

        return data;
    }


    document.addEventListener("DOMContentLoaded", () => {
        const modal = document.querySelector(".cfg-modal");
        if (!modal) return;

        const cfg = new ConfiguratorModal(modal);
        cfg.init();

        document.addEventListener("click", (e) => {
            const optionClick = e.target.closest(".option-selectors .opt-label, .option-selectors .js-option");
            console.log(1111111)
            if (!optionClick) return;

            if (optionClick.closest(".cfg-modal")) return;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

            cfg.open();
        }, true);

    });
})();
